export enum Permission {
  ConnectedStoresView = 'connected_stores.view',
  CaperModify = 'caper.modify',
  UposViewStatus = 'upos.view_status',
  ShelfLabelsModify = 'shelf_labels.modify',
}
